import { render, staticRenderFns } from "./ChangeMailModal.vue?vue&type=template&id=303f6396&scoped=true&"
import script from "./ChangeMailModal.vue?vue&type=script&lang=js&"
export * from "./ChangeMailModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMailModal.vue?vue&type=style&index=0&id=303f6396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303f6396",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('303f6396')) {
      api.createRecord('303f6396', component.options)
    } else {
      api.reload('303f6396', component.options)
    }
    module.hot.accept("./ChangeMailModal.vue?vue&type=template&id=303f6396&scoped=true&", function () {
      api.rerender('303f6396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyProfileMobile/ChangeMailModal.vue"
export default component.exports